export class UserDetails {
  uname: string;
  email: string;
  phone: number;
  roleName: string;
  hashValue: string;
  createdDate: string;
}

export class User {
  userId: number;
  userName: string;
  phone: number;
  email: string;
  activestatus: boolean;
  creadtedDate: string;
  spent: number;
  totalOrders: number;
}